import UIAlert from 'UIComponents/alert/UIAlert';
import I18n from 'I18n';
import { connect } from 'react-redux';
import { hideNewCodeSentAlert as hideNewCodeSentAlertAction, hideCodeCallAlert as hideCodeCallAlertAction } from '../../actions';
import { getIsNewCodeSentAlertVisible, getIsCodeCallAlertVisible, getPhoneNumber } from '../../selectors/TwoFactorAuth';
import { jsx as _jsx } from "react/jsx-runtime";
const NewCodeSentAlert = ({
  isNewCodeSentAlertVisible,
  isCodeCallAlertVisible,
  hideNewCodeSentAlert,
  hideCodeCallAlert,
  phoneNumber
}) => {
  if (isCodeCallAlertVisible) {
    return /*#__PURE__*/_jsx(UIAlert, {
      type: "success",
      closeable: true,
      onClose: hideCodeCallAlert,
      children: I18n.text('login.twoFactor.newCodeCall', {
        phoneNumber
      })
    });
  } else if (isNewCodeSentAlertVisible) {
    return /*#__PURE__*/_jsx(UIAlert, {
      type: "success",
      closeable: true,
      onClose: hideNewCodeSentAlert,
      children: I18n.text('login.twoFactor.newCode', {
        phoneNumber
      })
    });
  } else {
    return /*#__PURE__*/_jsx("div", {});
  }
};
const mapStateToProps = state => ({
  isNewCodeSentAlertVisible: getIsNewCodeSentAlertVisible(state),
  isCodeCallAlertVisible: getIsCodeCallAlertVisible(state),
  phoneNumber: getPhoneNumber(state)
});
export default connect(mapStateToProps, {
  hideNewCodeSentAlert: hideNewCodeSentAlertAction,
  hideCodeCallAlert: hideCodeCallAlertAction
})(NewCodeSentAlert);